import * as React from 'react';
import { Form } from '@ant-design/compatible';
import '@ant-design/compatible/assets/index.css';
import { Modal, Alert, Select, InputNumber } from 'antd';
import { FormComponentProps } from '@ant-design/compatible/lib/form/Form';
import { connect } from 'react-redux';
import { getCurrency, nullSafeGet } from '../../utils/DataAccessUtils';
import OWAsyncSelect from '../ow_async_select/OWAsyncSelect';
import { ContractorPrivateNetworksRestCrudThunksForSupplier } from '../../thunks/contractors_private_networks_thunks';

const FormItem = Form.Item;
export const DATE_FORMAT = 'MMMM D, YYYY h:mm a';

interface SubContractWorkOrderModalFormProps extends FormComponentProps {
	onSubmit: any;
	onCancel: any;
	createErrors: any;
	updateErrors: any;
	currentUser: any;
	supplierFacilities: any;
	fetchMultipleSupplierFacilitiesInPrivateNetwork: any;
	fetchSupplierFacilitiesInPrivateNetwork: any;
	visible: boolean;
	creating: boolean;
	updating: boolean;
	formData: any;
	fetchContractors: any;
	contractorPrivateNetworks: any;
	addWarrantySupplier: any;
}

class SubContractWorkOrderModalForm extends React.Component<
	SubContractWorkOrderModalFormProps,
	any
> {
	constructor(props) {
		super(props);
		this.state = {};
	}

	render() {
		const {
			visible,
			onCancel,
			onSubmit,
			form,
			formData,
			createErrors,
			updateErrors,
			contractorPrivateNetworks,
			fetchContractors,
			creating,
			updating,
		} = this.props;
		const { getFieldDecorator } = form;
		const okText = 'Subcontract';
		const titleText = 'Subcontract Work Order';
		const workOrderCurrency = getCurrency({ workOrder: formData });

		getFieldDecorator(`id`, { initialValue: nullSafeGet('id', formData) });
		return (
			<Modal
				visible={visible}
				width={600}
				title={titleText}
				okText={okText}
				onCancel={onCancel}
				onOk={onSubmit}
				closable={false}
				confirmLoading={creating || updating}
			>
				<Form layout="vertical" className="supplierForm">
					{createErrors.length > 0 ? (
						<FormItem>
							<Alert message={createErrors.join(' ')} type="error" />
						</FormItem>
					) : null}
					{updateErrors.length > 0 ? (
						<FormItem>
							<Alert message={updateErrors.join(' ')} type="error" />
						</FormItem>
					) : null}
					<Form.Item required={true} label="Contractor">
						{getFieldDecorator(
							'supplierFacilityId',
							{}
						)(
							<OWAsyncSelect
								stateSlice={contractorPrivateNetworks}
								targetCollectionName={'contractorPrivateNetworksIndex'}
								fetchMultiple={(ids, targetCollectionName) => {}}
								valueAccessor={(item) => item.supplierFacility.id}
								fetchData={(
									searchText,
									targetCollectionName,
									pagination,
									sorting,
									filters,
									addToTargetCollection
								) => {
									fetchContractors(
										{ name: searchText },
										targetCollectionName,
										pagination,
										sorting,
										filters,
										addToTargetCollection
									);
								}}
								renderRecord={(contractor) => (
									<Select.Option
										key={contractor.supplierFacility.id}
										value={contractor.supplierFacility.id}
									>
										{contractor.supplierFacility.displayName || contractor.supplierFacility.name}
									</Select.Option>
								)}
								sortBy={{ sort_by: 'name', order: 'ascend' }}
							/>
						)}
					</Form.Item>
					<FormItem label="Subcontractor NTE">
						{getFieldDecorator('subContractorNte', {
							initialValue: formData.subContractorNte,
						})(
							<InputNumber
								max={formData.nte}
								style={{ width: 200 }}
								addonAfter={workOrderCurrency.id}
							/>
						)}
					</FormItem>
				</Form>
			</Modal>
		);
	}
}

const mapStateToProps = (state, ownProps) => ({
	visible: ownProps.visible,
	onCancel: ownProps.onCancel,
	onSubmit: ownProps.onSubmit,
	supplierFacilities: state.supplier_facilities,
	currentUser: state.session.currentUser,
	createErrors: state.buyer_contacts.createErrors,
	updateErrors: state.buyer_contacts.updateErrors,
	creating: state.work_orders.creating,
	updating: state.work_orders.updating,
	contractorPrivateNetworks: state.contractor_private_networks,
});

const mapDispatchToProps = (dispatch) => ({
	fetchContractors: (params) =>
		dispatch(
			ContractorPrivateNetworksRestCrudThunksForSupplier.read(
				params,
				'contractorPrivateNetworksIndex'
			)
		),
});

export default connect(
	mapStateToProps,
	mapDispatchToProps
)(Form.create<SubContractWorkOrderModalFormProps>()(SubContractWorkOrderModalForm));
